(() => {
  let pending;
  const root = window.Shopify?.routes?.root || '/';
  async function clean() {
    const response = await fetch(`${root}cart.js`, {cache:'no-store'});
    if (!response.ok) throw new Error('cart unavailable');
    const cart = await response.json();
    for (const item of cart.items) {
      if (!item.properties?.Fotografie) continue;
      const properties = {...item.properties, Fotografie: ''};
      const result = await fetch(`${root}cart/change.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:item.key,quantity:item.quantity,properties})});
      if (!result.ok) throw new Error('cart update failed');
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.submitter?.name !== 'checkout' || form.dataset.ibPhotosClean === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter;
    button.disabled = true;
    pending ||= clean().finally(() => { pending = null; });
    pending.then(() => {
      form.dataset.ibPhotosClean = 'true';
      button.disabled = false;
      form.requestSubmit(button);
    }).catch(() => {
      button.disabled = false;
      let error = form.querySelector('[data-ib-cart-cleanup-error]');
      if (!error) {
        error = document.createElement('p');
        error.dataset.ibCartCleanupError = '';
        error.setAttribute('role','alert');
        form.append(error);
      }
      error.textContent = document.documentElement.dataset.ibCartCleanupError;
    });
  }, true);
})();
